import * as React from 'react';
import { Modal, Button, FormControl, Alert } from 'react-bootstrap';
import { IFindDsdResult } from '@nkr/models/index';
import { ClosedLoopAssignType } from '@nkr/enums/index';
import { IFindDsdResponse } from '@nkr/store/index';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, FirstDataRenderedEvent, GridReadyEvent, SelectionChangedEvent, ValueGetterParams } from 'ag-grid-community';
import { GridWrapper } from '../styles';
import { Utility } from '@nkr/services/utility';

interface IProps {
    show: boolean,
    centerId: number,
    search: string,
    onSearch: (centerId: number, search: string) => Promise<IFindDsdResponse>,
    onAssign: (id: number, type: ClosedLoopAssignType) => void,
    onCancel: () => void
}

interface IState {
    search: string,
    searchResults: IFindDsdResult[],
    selectedDsd: number,
    columnDefs: ColDef[]
}

class FindDsd extends React.Component<IProps, IState> {
    readonly state: IState = {
        search: '',
        searchResults: [],
        selectedDsd: 0,
        columnDefs: [
            {
                headerName: "Donor Name",
                field: "donorName",
                width: 200,
                valueGetter: (params: ValueGetterParams) => {
                    let data = params.data as IFindDsdResult;

                    if (data.donorName == '') {
                        return '--';
                    }

                    return data.donorName;
                }
            },

            {
                headerName: "Donor Email",
                field: "donorEmail",
                width: 200,
                valueGetter: (params: ValueGetterParams) => {
                    let data = params.data as IFindDsdResult;

                    if (data.donorEmail == '') {
                        return '--';
                    }

                    return data.donorEmail;
                }
            },

            {
                headerName: "DOB",
                field: "donorBirthDate",
                width: 200,
                comparator: Utility.dateComparator,
                valueGetter: (params: ValueGetterParams) => {
                    let data = params.data as IFindDsdResult;

                    if (data.donorBirthDate == '') {
                        return '--';
                    }

                    return data.donorBirthDate;
                }
            }
        ]
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        let search = nextProps.search != '' ? nextProps.search : '';

        this.setState({
            search
        }, () => {
            this.doSearch(search)
        });
    }

    handleSearchChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let search = e.currentTarget.value;

        this.setState({
            search
        }, () => {
            this.doSearch(search);
        });
    }

    handleRowClick = (event: SelectionChangedEvent) => {
        let selectedNodes = event.api.getSelectedNodes();
        let data = selectedNodes.length > 0 ? selectedNodes[0].data as IFindDsdResult : null;

        this.setState({
            selectedDsd: data != null ? data.id : -1
        });
    }

    handleAssign = () => {
        this.props.onAssign(this.state.selectedDsd, ClosedLoopAssignType.DonorShieldDirect);
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    doSearch = (search: string) => {
        if (search.length >= 3) {
            this.props.onSearch(this.props.centerId, search).then(response => {
                this.setState({
                    searchResults: response.data.results
                });
            })
        } else {
            this.setState({
                searchResults: []
            });
        }
    }

    render = () => {
        return (
            <Modal show={this.props.show} bsSize="large" backdrop='static' onHide={this.handleCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>Find DSD Record</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert>Please enter at least three (3) characters to search the donor name, donor email and date of birth. To provide multiple search terms, separate each with a space.</Alert>

                    <FormControl
                        style={{ marginBottom: 5 }}
                        value={this.state.search}
                        onChange={this.handleSearchChange}
                    />

                    <GridWrapper className="ag-theme-bootstrap">
                        <AgGridReact
                            defaultColDef={{
                                sortable: true,
                                suppressMenu: true
                            }}
                            columnDefs={this.state.columnDefs}
                            rowData={this.state.searchResults}
                            rowHeight={25}
                            suppressCellSelection={true}
                            rowSelection='single'
                            onGridReady={(e: GridReadyEvent) => e.api.sizeColumnsToFit()}
                            onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                            onSelectionChanged={this.handleRowClick}
                            noRowsOverlayComponentFramework={props =>
                                <>
                                    {this.state.search != '' && this.state.searchResults.length == 0 && (
                                        <>No DSD records found...</>
                                    )}

                                    {this.state.search == '' && this.state.searchResults.length == 0 && (
                                        <>Please enter a search term or two...</>
                                    )}
                                </>
                            }
                        />
                    </GridWrapper>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.handleAssign} disabled={this.state.selectedDsd == 0}>Assign Selected DSD Record</Button>
                    <Button onClick={this.handleCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default FindDsd;